export default __webpack_public_path__ + "static/media/portada_PaulinaVillalobos.8f2c2eee.jpg";